import { SocketOptions } from 'nchan';

export const ERROR_RECONNECTION_TIME = 2000; // 2s
export const DEFAULT_RECONNECT_TIMEOUT = 4000; // 4s
export const DEFAULT_SOCKET_OPTIONS: SocketOptions = {
  subscriber: 'websocket',
  reconnect: undefined,
  shared: undefined,
};

export enum SocketEvents {
  TransportSetup = 'transportSetup',
  TransportNativeCreated = 'transportNativeCreated',
  TransportNativeBeforeDestroy = 'transportNativeBeforeDestroy',
  Message = 'message',
  Connect = 'connect',
  Disconnect = 'disconnect',
  Error = 'error',
}

export const getSocketUrl = async (
  url: string | (() => string | Promise<string>),
) => {
  let socketUrl: string;

  if (typeof url === 'function') {
    socketUrl = await url();
  } else {
    socketUrl = url;
  }

  return socketUrl;
};
